export default __webpack_public_path__ + "static/media/carousel_right_arrow.774c17ad.png";